
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ActivityActionType = {
  CONNECTION: 'CONNECTION',
  DISCONNECTION: 'DISCONNECTION',
  ACCESS_DENIED: 'ACCESS_DENIED',
  KVPS_CHANGE: 'KVPS_CHANGE',
  VEHICLE_SEARCH_INIT: 'VEHICLE_SEARCH_INIT',
  DRAFT_CREATE: 'DRAFT_CREATE',
  DRAFT_UPDATE: 'DRAFT_UPDATE',
  DRAFT_DELETE: 'DRAFT_DELETE',
  CTM_VALIDATION: 'CTM_VALIDATION',
  IMPORT_FILE_RCE_CNIT: 'IMPORT_FILE_RCE_CNIT',
  USER_AGREEMENT_CREATE: 'USER_AGREEMENT_CREATE',
  USER_AGREEMENT_UPDATE: 'USER_AGREEMENT_UPDATE',
  USER_AGREEMENT_DEACTIVATE: 'USER_AGREEMENT_DEACTIVATE',
  USER_AGREEMENT_ACTIVATE: 'USER_AGREEMENT_ACTIVATE',
  RCE_CNIT_UPDATE: 'RCE_CNIT_UPDATE',
  RCE_CNIT_DELETE: 'RCE_CNIT_DELETE',
  ECOC_BATCH_RELANCE: 'ECOC_BATCH_RELANCE',
  ECOC_IMPORT_RELANCE: 'ECOC_IMPORT_RELANCE',
  CAR_VIEW_STATUS_CHECK: 'CAR_VIEW_STATUS_CHECK',
  RAPPROCHEMENT_MANUAL: 'RAPPROCHEMENT_MANUAL',
  RAPPROCHEMENT_BATCH: 'RAPPROCHEMENT_BATCH',
  FDM_REQUEST_CREATE: 'FDM_REQUEST_CREATE',
  FDM_REQUESTS_IMPORT: 'FDM_REQUESTS_IMPORT',
  FUD_CREATE: 'FUD_CREATE',
  BASE_VIN_FORCE_DELETE: 'BASE_VIN_FORCE_DELETE',
  BASE_VIN_FILE_IMPORT: 'BASE_VIN_FILE_IMPORT',
  CTM_UPDATE: 'CTM_UPDATE',
  CTM_DELETE: 'CTM_DELETE'
} as const

export type ActivityActionType = (typeof ActivityActionType)[keyof typeof ActivityActionType]


export const BatchType = {
  RAPPROCHEMENT: 'RAPPROCHEMENT',
  RELANCE_ECOC: 'RELANCE_ECOC',
  IMPORT_ECOC: 'IMPORT_ECOC',
  FU_REQUEST: 'FU_REQUEST',
  MI_SUBMIT: 'MI_SUBMIT',
  MI_RECEPTION: 'MI_RECEPTION',
  SAP_FACTURATION: 'SAP_FACTURATION',
  DI_ARIS: 'DI_ARIS',
  ARIS_RAC_EXPORT: 'ARIS_RAC_EXPORT',
  DELIVERY_ARIS_IMPORT: 'DELIVERY_ARIS_IMPORT',
  DELIVERY_IMPORT: 'DELIVERY_IMPORT',
  ARIS_RETURN_IMPORT: 'ARIS_RETURN_IMPORT',
  JNL_IMMAT_EXPORT: 'JNL_IMMAT_EXPORT',
  D4B_CAP_EXPORT: 'D4B_CAP_EXPORT',
  FDM_TIPP_EXPORT: 'FDM_TIPP_EXPORT',
  INIT_USER_ARGEEMENT: 'INIT_USER_ARGEEMENT',
  INIT_COLOR_RULES: 'INIT_COLOR_RULES',
  MI_RETURN_FU: 'MI_RETURN_FU',
  MI_DISPATCH_RECEPTION: 'MI_DISPATCH_RECEPTION',
  INIT_RCE_CNIT: 'INIT_RCE_CNIT',
  BASE_VIN_EXPORT: 'BASE_VIN_EXPORT',
  ZIP_RECEPTION: 'ZIP_RECEPTION',
  ZIP_SEND: 'ZIP_SEND',
  REFPART_CAT_IMPORT: 'REFPART_CAT_IMPORT',
  REFPART_DE_IMPORT: 'REFPART_DE_IMPORT',
  INIT_DELIVERY: 'INIT_DELIVERY'
} as const

export type BatchType = (typeof BatchType)[keyof typeof BatchType]


export const BrandLetter = {
  A: 'A',
  V: 'V',
  N: 'N',
  S: 'S',
  C: 'C'
} as const

export type BrandLetter = (typeof BrandLetter)[keyof typeof BrandLetter]


export const functionality = {
  CAT: 'CAT',
  H: 'H',
  RIN: 'RIN',
  SYSTEM: 'SYSTEM'
} as const

export type functionality = (typeof functionality)[keyof typeof functionality]


export const CommercialProtocol = {
  CAR: 'CAR',
  CAR3: 'CAR3'
} as const

export type CommercialProtocol = (typeof CommercialProtocol)[keyof typeof CommercialProtocol]


export const ActivityPath = {
  AVS: 'AVS',
  RETAIL: 'RETAIL',
  SYSTEM: 'SYSTEM'
} as const

export type ActivityPath = (typeof ActivityPath)[keyof typeof ActivityPath]


export const ActivityResult = {
  OK: 'OK',
  KO_METIER: 'KO_METIER',
  KO_TECH: 'KO_TECH'
} as const

export type ActivityResult = (typeof ActivityResult)[keyof typeof ActivityResult]


export const PaymentMode = {
  PA: 'PA',
  CP: 'CP'
} as const

export type PaymentMode = (typeof PaymentMode)[keyof typeof PaymentMode]


export const VinStatus = {
  CREATED: 'CREATED',
  ECOC_PENDING: 'ECOC_PENDING',
  ECOC_OK: 'ECOC_OK',
  ECOC_KO: 'ECOC_KO',
  ETIQUETTE_CO2_EDIT: 'ETIQUETTE_CO2_EDIT',
  ETIQUETTE_CO2_OK: 'ETIQUETTE_CO2_OK',
  CNIT_ASSIGNED: 'CNIT_ASSIGNED',
  CNIT_KO: 'CNIT_KO',
  FDM_OK: 'FDM_OK',
  FDM_EDIT: 'FDM_EDIT',
  READY_FOR_DELIVERED: 'READY_FOR_DELIVERED',
  DELIVERED: 'DELIVERED',
  BASE_VIN_OK: 'BASE_VIN_OK',
  BASE_VIN_KO: 'BASE_VIN_KO',
  READY_FOR_IMMATRICULATION: 'READY_FOR_IMMATRICULATION',
  IMMATRICULATION_IN_PROGRESS: 'IMMATRICULATION_IN_PROGRESS',
  IMMATRICULATION_TRA: 'IMMATRICULATION_TRA',
  IMMATRICULED_ACC: 'IMMATRICULED_ACC',
  IMMATRICULED_CPI: 'IMMATRICULED_CPI',
  IMMATRICULATION_REJECT: 'IMMATRICULATION_REJECT',
  READY_FOR_FIN_USAGE_DEMO: 'READY_FOR_FIN_USAGE_DEMO',
  FIN_USAGE_DEMO_IN_PROGRESS: 'FIN_USAGE_DEMO_IN_PROGRESS',
  FIN_USAGE_DEMO_TR: 'FIN_USAGE_DEMO_TR',
  FIN_USAGE_DEMO_ACC: 'FIN_USAGE_DEMO_ACC',
  FIN_USAGE_DEMO_REJECT: 'FIN_USAGE_DEMO_REJECT',
  BLOCKED: 'BLOCKED'
} as const

export type VinStatus = (typeof VinStatus)[keyof typeof VinStatus]


export const VinEvent = {
  ECOC_STATUS_UNKNOWN: 'ECOC_STATUS_UNKNOWN',
  ECOC_STATUS_400: 'ECOC_STATUS_400',
  ECOC_STATUS_NOT_400: 'ECOC_STATUS_NOT_400',
  ECOC_VALIDATE: 'ECOC_VALIDATE',
  CNIT_FOUND: 'CNIT_FOUND',
  CNIT_NOT_FOUND: 'CNIT_NOT_FOUND',
  ETIQUETTE_CO2_VALIDATE: 'ETIQUETTE_CO2_VALIDATE',
  ETIQUETTE_CO2_SEND: 'ETIQUETTE_CO2_SEND',
  FDM_VALIDATE: 'FDM_VALIDATE',
  FDM_REQUEST: 'FDM_REQUEST',
  VN_READY_FOR_DELIVERY: 'VN_READY_FOR_DELIVERY',
  CREATE_DELIVERY: 'CREATE_DELIVERY',
  DELETE_DELIVERY: 'DELETE_DELIVERY',
  VN_NOT_SETTLED: 'VN_NOT_SETTLED',
  VN_BLOCKED: 'VN_BLOCKED',
  VN_SETTLED_NO_BLOCK: 'VN_SETTLED_NO_BLOCK',
  NADIN_BLOCK: 'NADIN_BLOCK',
  READY_FOR_IMMAT: 'READY_FOR_IMMAT',
  CREATE_IMMATRICULATION: 'CREATE_IMMATRICULATION',
  DELETE_IMMATRICULATION: 'DELETE_IMMATRICULATION',
  SEND_MI: 'SEND_MI',
  RECEIVE_MI_ACCEPTED: 'RECEIVE_MI_ACCEPTED',
  RECEIVE_MI_REJECTED: 'RECEIVE_MI_REJECTED',
  UPDATE_IMMATRICULATION: 'UPDATE_IMMATRICULATION',
  RECEIVE_JOURNAL: 'RECEIVE_JOURNAL',
  READY_FOR_FIN_USAGE_DEMO: 'READY_FOR_FIN_USAGE_DEMO',
  CREATE_FIN_USAGE_DEMO: 'CREATE_FIN_USAGE_DEMO',
  DELETE_FIN_USAGE_DEMO: 'DELETE_FIN_USAGE_DEMO',
  SEND_MI_FIN_USAGE: 'SEND_MI_FIN_USAGE',
  RECEIVE_MI_FIN_USAGE_ACCEPTED: 'RECEIVE_MI_FIN_USAGE_ACCEPTED',
  RECEIVE_MI_FIN_USAGE_REJECTED: 'RECEIVE_MI_FIN_USAGE_REJECTED',
  UPDATE_FIN_USAGE_DEMO: 'UPDATE_FIN_USAGE_DEMO',
  BLOCK: 'BLOCK',
  ADMIN_RESET: 'ADMIN_RESET'
} as const

export type VinEvent = (typeof VinEvent)[keyof typeof VinEvent]


export const NsivStatus = {
  DRAFT: 'DRAFT',
  READY_FOR_SUBMITTED: 'READY_FOR_SUBMITTED',
  SUBMITTED: 'SUBMITTED',
  ACCEPTED: 'ACCEPTED',
  CPI_DELIVERED: 'CPI_DELIVERED',
  REJECTED: 'REJECTED'
} as const

export type NsivStatus = (typeof NsivStatus)[keyof typeof NsivStatus]


export const AakAccountingFlag = {
  F: 'F',
  I: 'I',
  T: 'T',
  Z: 'Z'
} as const

export type AakAccountingFlag = (typeof AakAccountingFlag)[keyof typeof AakAccountingFlag]


export const DeliveryNature = {
  L: 'L',
  D: 'D',
  R: 'R',
  T: 'T'
} as const

export type DeliveryNature = (typeof DeliveryNature)[keyof typeof DeliveryNature]


export const NetworkFlag = {
  N: 'N',
  O: 'O',
  T: 'T'
} as const

export type NetworkFlag = (typeof NetworkFlag)[keyof typeof NetworkFlag]


export const WarrantyStart = {
  A: 'A'
} as const

export type WarrantyStart = (typeof WarrantyStart)[keyof typeof WarrantyStart]


export const ColorExclusiveProgram = {
  O: 'O',
  N: 'N'
} as const

export type ColorExclusiveProgram = (typeof ColorExclusiveProgram)[keyof typeof ColorExclusiveProgram]


export const FacturationCode = {
  FDM: 'FDM',
  VN: 'VN',
  FU: 'FU',
  VO: 'VO',
  DA: 'DA',
  CS: 'CS'
} as const

export type FacturationCode = (typeof FacturationCode)[keyof typeof FacturationCode]


export const DeliveryStatus = {
  TO_DECLARE: 'TO_DECLARE',
  DECLARED: 'DECLARED',
  CANCELLED: 'CANCELLED'
} as const

export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus]


export const DeliveryHistoryAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  CANCEL: 'CANCEL',
  BASE_VIN_DELETE: 'BASE_VIN_DELETE'
} as const

export type DeliveryHistoryAction = (typeof DeliveryHistoryAction)[keyof typeof DeliveryHistoryAction]


export const RejectionRequestType = {
  DI: 'DI',
  FU: 'FU'
} as const

export type RejectionRequestType = (typeof RejectionRequestType)[keyof typeof RejectionRequestType]


export const RejectionType = {
  FUNCTIONAL: 'FUNCTIONAL',
  TECHNICAL: 'TECHNICAL'
} as const

export type RejectionType = (typeof RejectionType)[keyof typeof RejectionType]


export const RejectionSource = {
  MI_RECEPTION: 'MI_RECEPTION',
  FU_MI_RETURN: 'FU_MI_RETURN'
} as const

export type RejectionSource = (typeof RejectionSource)[keyof typeof RejectionSource]


export const ImportErrorType = {
  STRUCTURE_ERROR: 'STRUCTURE_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BUSINESS_ERROR: 'BUSINESS_ERROR',
  DUPLICATE: 'DUPLICATE'
} as const

export type ImportErrorType = (typeof ImportErrorType)[keyof typeof ImportErrorType]


export const fileType = {
  SUP_3T5: 'SUP_3T5',
  INF_3T5: 'INF_3T5',
  FDM: 'FDM',
  ECOC: 'ECOC',
  MI_RECEPTION: 'MI_RECEPTION',
  FU_MI_RETURN: 'FU_MI_RETURN',
  MI_JNL_RECEPTION: 'MI_JNL_RECEPTION',
  MI_DISPATCH_RECEPTION: 'MI_DISPATCH_RECEPTION',
  BASE_VIN_SUPP: 'BASE_VIN_SUPP',
  DELIVERY_ARIS: 'DELIVERY_ARIS',
  DELIVERY_NCONS: 'DELIVERY_NCONS',
  ARIS_RETURN: 'ARIS_RETURN',
  INIT_COLOR_RULES: 'INIT_COLOR_RULES',
  INIT_USER_ARGEEMENT: 'INIT_USER_ARGEEMENT',
  INIT_RCE_CNIT: 'INIT_RCE_CNIT',
  REFPART_CAT: 'REFPART_CAT',
  REFPART_DE: 'REFPART_DE',
  INIT_DELIVERY: 'INIT_DELIVERY'
} as const

export type fileType = (typeof fileType)[keyof typeof fileType]


export const ImportStatus = {
  SUCCESS: 'SUCCESS',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  FAILED: 'FAILED'
} as const

export type ImportStatus = (typeof ImportStatus)[keyof typeof ImportStatus]


export const FileSource = {
  FILE_SYSTEM: 'FILE_SYSTEM',
  MANUAL_IMPORT: 'MANUAL_IMPORT'
} as const

export type FileSource = (typeof FileSource)[keyof typeof FileSource]


export const FileImportStatus = {
  COMPLETED: 'COMPLETED',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED'
} as const

export type FileImportStatus = (typeof FileImportStatus)[keyof typeof FileImportStatus]


export const BatchStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PARTIAL: 'PARTIAL',
  RUNNING: 'RUNNING'
} as const

export type BatchStatus = (typeof BatchStatus)[keyof typeof BatchStatus]


export const OptionCode = {
  A: 'A',
  B: 'B',
  V: 'V'
} as const

export type OptionCode = (typeof OptionCode)[keyof typeof OptionCode]


export const FileImportType = {
  RAPPROCHEMENT: 'RAPPROCHEMENT',
  RELANCE_ECOC: 'RELANCE_ECOC',
  IMPORT_ECOC: 'IMPORT_ECOC'
} as const

export type FileImportType = (typeof FileImportType)[keyof typeof FileImportType]


export const RapprochementStatus = {
  OK: 'OK',
  KO: 'KO'
} as const

export type RapprochementStatus = (typeof RapprochementStatus)[keyof typeof RapprochementStatus]


export const FdmRequestStatus = {
  PENDING: 'PENDING',
  ERREUR: 'ERREUR',
  DISPONIBLE: 'DISPONIBLE'
} as const

export type FdmRequestStatus = (typeof FdmRequestStatus)[keyof typeof FdmRequestStatus]


export const FinUsageStatus = {
  READY_FOR_SUBMITTED: 'READY_FOR_SUBMITTED',
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
} as const

export type FinUsageStatus = (typeof FinUsageStatus)[keyof typeof FinUsageStatus]


export const EndUsageReason = {
  VENTE: 'VENTE',
  AFFECTATION: 'AFFECTATION'
} as const

export type EndUsageReason = (typeof EndUsageReason)[keyof typeof EndUsageReason]


export const Environment = {
  PRELIVE: 'PRELIVE',
  PRODUCTION: 'PRODUCTION',
  TEST: 'TEST'
} as const

export type Environment = (typeof Environment)[keyof typeof Environment]


export const SapFacturationSourceType = {
  VN: 'VN',
  FU: 'FU',
  FDM: 'FDM'
} as const

export type SapFacturationSourceType = (typeof SapFacturationSourceType)[keyof typeof SapFacturationSourceType]


export const SapFacturationRunStatus = {
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type SapFacturationRunStatus = (typeof SapFacturationRunStatus)[keyof typeof SapFacturationRunStatus]


export const QueueEntityType = {
  FinUsageDem: 'FinUsageDem',
  ImmatriculationVn: 'ImmatriculationVn',
  MiReturnFile: 'MiReturnFile'
} as const

export type QueueEntityType = (typeof QueueEntityType)[keyof typeof QueueEntityType]


export const MiQueueStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
  FAILED: 'FAILED',
  RETRY: 'RETRY'
} as const

export type MiQueueStatus = (typeof MiQueueStatus)[keyof typeof MiQueueStatus]


export const FundingType = {
  VWFS: 'VWFS',
  OTHER: 'OTHER',
  CREDIT: 'CREDIT',
  CASH: 'CASH'
} as const

export type FundingType = (typeof FundingType)[keyof typeof FundingType]


export const VwfsType = {
  LOUN: 'LOUN',
  LLDFI: 'LLDFI',
  LOA: 'LOA',
  FINANCE_LEASE: 'FINANCE_LEASE'
} as const

export type VwfsType = (typeof VwfsType)[keyof typeof VwfsType]


export const OtherLeasingType = {
  LLD: 'LLD',
  LOA: 'LOA'
} as const

export type OtherLeasingType = (typeof OtherLeasingType)[keyof typeof OtherLeasingType]


export const Action = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
} as const

export type Action = (typeof Action)[keyof typeof Action]


export const FileExportType = {
  ARIS_RAC: 'ARIS_RAC',
  JNL_IMMAT: 'JNL_IMMAT',
  D4B_CAP: 'D4B_CAP',
  BASE_VIN: 'BASE_VIN',
  FDM_TIPP: 'FDM_TIPP'
} as const

export type FileExportType = (typeof FileExportType)[keyof typeof FileExportType]


export const FileExportStatus = {
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
  FAILED: 'FAILED'
} as const

export type FileExportStatus = (typeof FileExportStatus)[keyof typeof FileExportStatus]


export const FileExportLineStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type FileExportLineStatus = (typeof FileExportLineStatus)[keyof typeof FileExportLineStatus]


export const OperationType = {
  DCT: 'DCT',
  DCL: 'DCL',
  DVD: 'DVD'
} as const

export type OperationType = (typeof OperationType)[keyof typeof OperationType]
